import React from "react";
import { Text } from "src/components/ui/Text";
import { TableVirtuoso } from "react-virtuoso";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";
import {
  AccidentIcon,
  BatteryLowIcon,
  ChargingIcon,
  NoReportIcon,
  OfflineIcon,
  OnlineIcon,
} from "../icons";

const columnsTruck = [
  {
    width: 160,
    label: "Updated",
    dataKey: "updated",
  },
  {
    width: 160,
    label: "License plate",
    dataKey: "license",
  },
  {
    width: 160,
    label: "Truck name",
    dataKey: "truckName",
  },
  {
    width: 280,
    label: "Location",
    dataKey: "location",
    centerColumn: true,
  },
  {
    width: 160,
    label: "Speed",
    dataKey: "speed",
    centerColumn: true,
  },
  {
    width: 160,
    label: "Remaining distance",
    dataKey: "remaining_distance",
    centerColumn: true,
  },
  {
    width: 160,
    label: "Status",
    dataKey: "status",
  },
  {
    width: 160,
    label: "Capacity",
    dataKey: "capacity",
  },
  
  {
    width: 300,
    label: "Remarks",
    dataKey: "remarks",
  },
];

const columnsCharged = [
  {
    width: 160,
    label: "Updated",
    dataKey: "updated",
  },
  {
    width: 160,
    label: "License plate",
    dataKey: "license",
  },
  {
    width: 210,
    label: "Account",
    dataKey: "account",
  },
  {
    width: 160,
    label: "Charged time",
    dataKey: "chargedTime",
  },
  {
    width: 210,
    label: "Charged",
    dataKey: "charged",
    centerColumn: true,
  },
  {
    width: 160,
    label: "Status",
    dataKey: "status",
  },
  {
    width: 300,
    label: "Remarks",
    dataKey: "remarks",
  },
];

const TableLists = ({ infoView, reportInformation }) => {
  const isNotEmptyRecordDetails = reportInformation?.record?.detail?.length > 0;


  function createDataVehicle(
    updated,
    license,
    truckName,
    location,
    speed,
    remaining_distance,
    status,
    capacity,
    remarks
  ) {
    return { updated, license, truckName, location, speed, remaining_distance, status, capacity, remarks };
  }
  function createDataCharged(
    updated,
    license,
    account,
    chargedTime,
    charged,
    status,
    remarks
  ) {
    return { updated, license, account, chargedTime, charged, status, remarks };
  }

  

  const columnsFooterTruck = [
    {
      width: 160,
      label: "Total distance",
      dataKey: "total distance",
    },
    {
      width: 160,
      label: "",
      dataKey: "license",
    },
    {
      width: 160,
      label: "",
      dataKey: "truckName",
    },
    {
      width: 240,
      label: "",
      dataKey: "location",
      centerColumn: true,
    },
    {
      width: 160,
      label: "",
      dataKey: "speed",
    },
    {
      width: 160,
      label: `${reportInformation?.record?.total?.distance?.value === "-" ? "-" : reportInformation?.record?.total?.distance?.value ?? "-"} ${reportInformation?.record?.total?.distance?.unit ?? ""}`,
      dataKey: "remaining_distance",
      centerColumn: true,
    },
    {
      width: 160,
      label: "",
      dataKey: "status",
    },
    {
      width: 160,
      label: `${reportInformation?.record?.total?.door_opening_count?.value === "-" ? "-" : reportInformation?.record?.total?.door_opening_count?.value ?? "-"} ${reportInformation?.record?.total?.door_opening_count?.unit ?? ""}`,
      dataKey: "capacity",
    },
    
    {
      width: 300,
      label: "",
      dataKey: "remarks",
    },
  ];

  const columnsFooterCharged = [
    {
      width: 160,
      label: "Total charge",
      dataKey: "total charge",
    },
    {
      width: 160,
      label: "",
      dataKey: "license",
    },
    {
      width: 210,
      label: "",
      dataKey: "account",
    },
    {
      width: 160,
      label: reportInformation?.record?.total
        ? `${reportInformation?.record?.total["time"]}`
        : "",
      dataKey: "chargedTime",
    },
    {
      width: 210,
      label: reportInformation?.record?.total
        ? `${reportInformation?.record?.total[
            "charge"
          ]?.value?.toLocaleString()} ${
            reportInformation?.record?.total["charge"]?.unit
          }`
        : "",
      dataKey: "charged",
      centerColumn: true,
    },
    {
      width: 160,
      label: "",
      dataKey: "status",
    },
    {
      width: 300,
      label: "",
      dataKey: "remarks",
    },
  ];

  const rows = isNotEmptyRecordDetails
    ? reportInformation?.record?.detail.map((detail) => {
        if (infoView === "truck") {
          const arrInfoVehicle = [
            `${detail?.datetime_updated || ""}`,
            `${detail?.license_plate || ""}`,
            `${detail?.name || ""}`,
            `${(detail?.location?.lat && detail?.location?.lon && detail?.location?.lat !== "-" && detail?.location?.lon !== "-") ? `${detail.location.lat}, ${detail.location.lon}` : "-"}`,
            `${detail?.speed?.value === "-" ? "-" : (detail?.speed?.value ? `${detail.speed.value} ${detail.speed.unit}` : `${detail.speed.value} ${detail.speed.unit}`)}`,
            `${detail?.remaining_distance?.value === "-" ? "-" : (detail?.remaining_distance?.value ? `${detail.remaining_distance.value} ${detail.remaining_distance.unit}` : `${detail.remaining_distance.value} ${detail.remaining_distance.unit}`)}`,
            `${detail?.status || ""}`,
            `${detail?.capacity?.value === "-" ? "-" : (detail?.capacity?.value ? `${detail.capacity.value} ${detail.capacity.unit}` : "-")}`,
            `${detail?.remark || ""}`,
          ];
          const createData = createDataVehicle(...arrInfoVehicle);
          return createData;
        } else {
          const arrInfoCharger = [
            `${detail?.datetime_updated || ""}`,
            `${detail?.license_plate || ""}`,
            `${detail?.account || ""}`,
            `${detail?.charge_time || ""}`,
            `${detail?.charge?.value?.toLocaleString() || ""} ${
              detail?.charge?.unit || ""
            }`,
            `${detail?.status || ""}`,
            `${detail?.remark || ""}`,
          ];

          const createData = createDataCharged(...arrInfoCharger);
          return createData;
        }
      })
    : [];

  const VirtuosoTableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => (
      <Table
        {...props}
        sx={{
          borderCollapse: "separate",
          tableLayout: "fixed",
        }}
      />
    ),
    TableHead,
    TableRow: ({ item: _item, ...props }) => <TableRow {...props} />,
    TableBody: React.forwardRef((props, ref) => (
      <TableBody {...props} ref={ref} />
    )),
  };

  function fixedHeaderContent() {
    return (
      <TableRow>
        {infoView === "truck"
          ? columnsTruck.map((column) => (
              <TableCell
                key={column.dataKey}
                variant="head"
                align={column.centerColumn || false ? "center" : "left"}
                style={{ width: column.width }}
                sx={{
                  backgroundColor: "background.paper",
                  padding: "13px 8px",
                }}
              >
                <Text variant="medium-12" className="text-secondary">
                  {column.label}
                </Text>
              </TableCell>
            ))
          : columnsCharged.map((column) => (
              <TableCell
                key={column.dataKey}
                variant="head"
                align={column.centerColumn || false ? "center" : "left"}
                style={{ width: column.width }}
                sx={{
                  backgroundColor: "background.paper",
                  padding: "13px 8px",
                }}
              >
                <Text variant="medium-12" className="text-secondary">
                  {column.label}
                </Text>
              </TableCell>
            ))}
      </TableRow>
    );
  }

  function fixedFooterContent() {
    return (
      <TableRow>
        {infoView === "truck"
          ? columnsFooterTruck.map((column) => (
              <TableCell
                key={column.dataKey}
                variant="footer"
                align={column.centerColumn || false ? "center" : "left"}
                style={{ width: column.width }}
                sx={{
                  backgroundColor: "#F1F3F5",
                  padding: "12px 8px",
                }}
              >
                <Text variant="bold-14" className="text-vekin-green100">
                  {column.label}
                </Text>
              </TableCell>
            ))
          : columnsFooterCharged.map((column) => (
              <TableCell
                key={column.dataKey}
                variant="head"
                align={column.centerColumn || false ? "center" : "left"}
                style={{ width: column.width }}
                sx={{
                  backgroundColor: "#F1F3F5",
                  padding: "12px 8px",
                }}
              >
                <Text variant="bold-14" className="text-vekin-green100">
                  {column.label}
                </Text>
              </TableCell>
            ))}
      </TableRow>
    );
  }

  function rowContent(_index, row) {
    const IconStatusTruck = (nameStatus) => {
      switch (nameStatus) {
        case "driving":
          return (
            <div className="flex items-center gap-1">
              <OnlineIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-green100">
                Driving
              </Text>
            </div>
          );

        case "charging":
          return (
            <div className="flex items-center gap-1">
              <ChargingIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-blue10">
                Charging
              </Text>
            </div>
          );

        case "parking":
          return (
            <div className="flex items-center gap-1">
              <OfflineIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-quartenary">
                Parking
              </Text>
            </div>
          );

        case "accident":
          return (
            <div className="flex items-center gap-1">
              <AccidentIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-red10">
                Accident
              </Text>
            </div>
          );

        case "battery low":
          return (
            <div className="flex items-center gap-1">
              <BatteryLowIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-yellow10">
                Battery low
              </Text>
            </div>
          );

          case "offline":
            return (
              <div className="flex items-center gap-1">
              <OfflineIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-quartenary">
                Offline
              </Text>
            </div>
            );

        default:
          return <div></div>;
      }
    };

    const IconStatusCharger = (nameStatus) => {
      switch (nameStatus) {
        case "standby":
          return (
            <div className="flex items-center gap-1">
              <OnlineIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-green100">
                Standby
              </Text>
            </div>
          );

        case "charging":
          return (
            <div className="flex items-center gap-1">
              <ChargingIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-blue10">
                Charging
              </Text>
            </div>
          );

        case "active":
          return (
            <div className="flex items-center gap-1">
              <OfflineIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-quartenary">
                Active
              </Text>
            </div>
          );

        case "fail":
          return (
            <div className="flex items-center gap-1">
              <AccidentIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-red10">
                Fail
              </Text>
            </div>
          );

        case "finishing":
          return (
            <div className="flex items-center gap-1">
              <BatteryLowIcon className="w-[14px] h-[14px]" />
              <Text variant="bold-12" className="text-vekin-yellow10">
                Finishing
              </Text>
            </div>
          );

        default:
          return <div></div>;
      }
    };

    return (
      <React.Fragment>
        {infoView === "truck"
          ? columnsTruck.map((column) => (
              <TableCell
                key={column.dataKey}
                align={column.centerColumn || false ? "center" : "left"}
                sx={{
                  padding: "12px 8px",
                }}
              >
                {column.label !== "Status" ? (
                  <Text variant="semi-14" className="text-primary">
                    {row[column.dataKey]}
                  </Text>
                ) : (
                  <div>{IconStatusTruck(row[column.dataKey])}</div>
                )}
              </TableCell>
            ))
          : columnsCharged.map((column) => (
              <TableCell
                key={column.dataKey}
                align={column.centerColumn || false ? "center" : "left"}
                sx={{
                  padding: "12px 8px",
                }}
              >
                {column.label !== "Status" ? (
                  <Text variant="semi-14" className="text-primary">
                    {row[column.dataKey]}
                  </Text>
                ) : (
                  <div>{IconStatusCharger(row[column.dataKey])}</div>
                )}
              </TableCell>
            ))}
      </React.Fragment>
    );
  }

  return (
    <Paper
      style={{
        height: 450,
        width: "100%",
        position: "relative",
        boxShadow: "none",
        borderRadius: "0 0 8px 8px",
      }}
    >
      <TableVirtuoso
        data={rows}
        components={VirtuosoTableComponents}
        fixedHeaderContent={fixedHeaderContent}
        fixedFooterContent={isNotEmptyRecordDetails && fixedFooterContent}
        itemContent={rowContent}
        style={{
          boxShadow: "none",
          borderRadius: "0 0 8px 8px",
        }}
      />

      {/* when haven't the data of detail  */}
      {!isNotEmptyRecordDetails && (
        <div className="absolute top-0 bottom-0 flex items-center justify-center w-full z-60">
          <div className="flex flex-col items-center justify-center gap-2 pt-3">
            <NoReportIcon />
            <Text variant="bold-16" className="text-tertiary">
              No record found
            </Text>
          </div>
        </div>
      )}
    </Paper>
  );
};

export default TableLists;
